import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import {
  aiChatRequestCodec,
  aiChatResponseCodec,
} from './codec';
import {
  createAuthorizedPostRequest,
  decode,
  fetchApi,
  setBody,
} from '../..';

const aiChatUrl = '/v2/ai-chat/query';

export const sendMessage = (query: string, previousMessages: string[]) => pipe(
  aiChatUrl,
  createAuthorizedPostRequest,
  map(setBody(aiChatRequestCodec.encode({
    query,
    previous_messages: previousMessages,
  }))),
  chain(fetchApi),
  chain(decode(aiChatResponseCodec)),
);
